
export class LayoutHelper
{

  public static getTopFromElement(elementId: string, defaultValue: number): number
  {
    const divContainer = document.getElementById(elementId);
    // console.log('divContainer:', divContainer);
    if (divContainer)
    {
      const position = divContainer.getBoundingClientRect();
      if (position)
        return position.top;
    }
    return defaultValue;
  }

  public static getHeightFromElement(elementId: string, defaultValue: number): number
  {
    const divContainer = document.getElementById(elementId);
    // console.log('divContainer:', divContainer);
    if (divContainer)
    {
      const boundingClientRect = divContainer.getBoundingClientRect();
      if (boundingClientRect)
        return boundingClientRect.height;
    }
    return defaultValue;
  }

}
